import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

const BackBoxIcon = createSvgIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1265_2418)">
      <path
        d="M14.6972 3.26178L14.6972 3.26178L8.21613 0.599306L8.21612 0.599303C8.07763 0.54242 7.9223 0.54242 7.7838 0.599303L7.7838 0.599306L1.30275 3.26178C1.19842 3.30464 1.10918 3.37755 1.04639 3.47124C0.983586 3.56494 0.950057 3.67518 0.950058 3.78797V12.212C0.950057 12.3248 0.983586 12.435 1.04639 12.5287C1.10918 12.6224 1.19842 12.6953 1.30275 12.7382L7.78373 15.4006C7.78375 15.4007 7.78378 15.4007 7.7838 15.4007C7.92075 15.457 8.07425 15.4575 8.21152 15.4023L8.21273 15.4018L8.21512 15.4009L8.2195 15.3992L8.28539 15.3722L8.93789 15.1042L14.6972 12.7382C14.8015 12.6953 14.8907 12.6224 14.9535 12.5287C15.0163 12.435 15.0499 12.3248 15.0499 12.212V3.78797C15.0499 3.67518 15.0163 3.56494 14.9535 3.47125C14.8907 3.37756 14.8015 3.30465 14.6972 3.26178ZM8.08156 15.3425C8.07833 15.3375 8.07538 15.3325 8.0728 15.3274C8.07449 15.3272 8.07617 15.3269 8.07786 15.3266C8.07887 15.332 8.0801 15.3373 8.08156 15.3425ZM8.18251 15.4085C8.18366 15.4084 8.18481 15.4083 8.18592 15.4082C8.18507 15.4083 8.18427 15.4084 8.18356 15.4084C8.18324 15.4085 8.18289 15.4085 8.18251 15.4085ZM8.13187 15.3967C8.14521 15.4022 8.15819 15.4062 8.16701 15.408C8.16039 15.4075 8.15321 15.4067 8.14758 15.4057C8.14296 15.4039 8.1376 15.4008 8.13187 15.3967ZM8.26065 15.3656C8.26362 15.3604 8.26722 15.3528 8.2707 15.3439C8.26958 15.3497 8.26812 15.3545 8.26638 15.3581C8.26471 15.3605 8.26273 15.363 8.26065 15.3656ZM8.24446 15.3831C8.24498 15.3827 8.24556 15.3821 8.24619 15.3816L8.24482 15.3828C8.24471 15.3829 8.24458 15.383 8.24446 15.3831ZM2.08778 4.67525L3.99628 5.45928L3.99625 5.45936L4.00027 5.46083L4.45517 5.62736L4.9102 5.83464L4.91017 5.83471L4.914 5.83629L7.4311 6.87033V14.0258L2.08778 11.8307V4.67525ZM8.22603 15.3957L8.22956 15.3937C8.22718 15.3951 8.2233 15.3972 8.22603 15.3957ZM7.99996 5.87404L5.89402 5.00891L10.774 2.88009L13.031 3.80727L7.99996 5.87404ZM7.99996 1.74048L9.30858 2.27807L4.42861 4.40689L2.96897 3.80725L7.99996 1.74048ZM8.56882 14.0258V6.87033L13.9121 4.67525V11.8307L8.56882 14.0258Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.220001"
      />
      <mask
        id="path-2-outside-1_1265_2418"
        maskUnits="userSpaceOnUse"
        x="2.80675"
        y="6.68464"
        width="7.07107"
        height="7.07107"
        fill="black"
      >
        <rect
          fill="currentColor"
          x="2.80675"
          y="6.68464"
          width="7.07107"
          height="7.07107"
        />
        <path d="M6.34229 12.3415L6.91622 11.7676L5.88601 10.7373L6.91621 10.7373L6.91621 9.92809L5.88601 9.92809L6.91622 8.89787L6.34229 8.32393L4.33351 10.3327L6.34229 12.3415Z" />
      </mask>
      <path
        d="M6.34229 12.3415L6.91622 11.7676L5.88601 10.7373L6.91621 10.7373L6.91621 9.92809L5.88601 9.92809L6.91622 8.89787L6.34229 8.32393L4.33351 10.3327L6.34229 12.3415Z"
        fill="currentColor"
      />
      <path
        d="M6.34229 12.3415L6.18672 12.4971C6.27264 12.583 6.41193 12.583 6.49785 12.4971L6.34229 12.3415ZM6.91622 11.7676L7.07179 11.9231C7.1577 11.8372 7.1577 11.6979 7.07179 11.612L6.91622 11.7676ZM5.88601 10.7373L5.88601 10.5173C5.79702 10.5173 5.7168 10.5709 5.68275 10.6531C5.6487 10.7354 5.66752 10.83 5.73044 10.8929L5.88601 10.7373ZM6.91621 10.7373L6.91621 10.9573L7.13621 10.9573L7.13621 10.7373L6.91621 10.7373ZM6.91621 9.92809H7.13621V9.70809L6.91621 9.70809L6.91621 9.92809ZM5.88601 9.92809L5.73044 9.77252C5.66752 9.83544 5.6487 9.93007 5.68275 10.0123C5.7168 10.0945 5.79702 10.1481 5.886 10.1481L5.88601 9.92809ZM6.91622 8.89787L7.07179 9.05343C7.1577 8.96752 7.1577 8.82822 7.07179 8.7423L6.91622 8.89787ZM6.34229 8.32393L6.49785 8.16837C6.41193 8.08245 6.27264 8.08245 6.18672 8.16837L6.34229 8.32393ZM4.33351 10.3327L4.17794 10.1771C4.09203 10.2631 4.09203 10.4024 4.17794 10.4883L4.33351 10.3327ZM6.49785 12.4971L7.07179 11.9231L6.76066 11.612L6.18672 12.1859L6.49785 12.4971ZM7.07179 11.612L6.04157 10.5818L5.73044 10.8929L6.76066 11.9231L7.07179 11.612ZM5.886 10.9573L6.91621 10.9573L6.91621 10.5173L5.88601 10.5173L5.886 10.9573ZM7.13621 10.7373L7.13621 9.92809H6.69621L6.69621 10.7373L7.13621 10.7373ZM6.91621 9.70809L5.88601 9.70808L5.886 10.1481L6.91621 10.1481L6.91621 9.70809ZM6.04157 10.0836L7.07179 9.05343L6.76066 8.7423L5.73044 9.77252L6.04157 10.0836ZM7.07179 8.7423L6.49785 8.16837L6.18672 8.47949L6.76066 9.05343L7.07179 8.7423ZM6.18672 8.16837L4.17794 10.1771L4.48907 10.4883L6.49785 8.47949L6.18672 8.16837ZM4.17794 10.4883L6.18672 12.4971L6.49785 12.1859L4.48907 10.1771L4.17794 10.4883Z"
        fill="currentColor"
        mask="url(#path-2-outside-1_1265_2418)"
      />
      <mask
        id="path-4-outside-2_1265_2418"
        maskUnits="userSpaceOnUse"
        x="7.43525"
        y="7.75853"
        width="5.65685"
        height="5.65686"
        fill="black"
      >
        <rect
          fill="currentColor"
          x="7.43525"
          y="7.75853"
          width="5.65685"
          height="5.65686"
        />
        <path d="M11.5276 10.7373L8.9999 10.7374L8.9999 9.92815L11.5275 9.92805L11.5276 10.7373Z" />
      </mask>
      <path
        d="M11.5276 10.7373L8.9999 10.7374L8.9999 9.92815L11.5275 9.92805L11.5276 10.7373Z"
        fill="currentColor"
      />
      <path
        d="M8.9999 10.7374L8.7799 10.7374L8.7799 10.9574L8.99991 10.9574L8.9999 10.7374ZM11.5276 10.7373L11.5276 10.9573C11.6491 10.9573 11.7476 10.8588 11.7476 10.7373L11.5276 10.7373ZM11.5275 9.92805L11.7476 9.92805C11.7476 9.8697 11.7244 9.81374 11.6831 9.77248C11.6419 9.73122 11.5859 9.70804 11.5275 9.70804L11.5275 9.92805ZM8.9999 9.92815L8.99989 9.70815L8.7799 9.70816L8.7799 9.92815L8.9999 9.92815ZM8.99991 10.9574L11.5276 10.9573L11.5275 10.5173L8.99989 10.5174L8.99991 10.9574ZM11.7476 10.7373L11.7476 9.92805L11.3075 9.92805L11.3075 10.7373L11.7476 10.7373ZM11.5275 9.70804L8.99989 9.70815L8.99991 10.1482L11.5276 10.148L11.5275 9.70804ZM9.2199 10.7374L9.2199 9.92815L8.7799 9.92815L8.7799 10.7374L9.2199 10.7374Z"
        fill="currentColor"
        mask="url(#path-4-outside-2_1265_2418)"
      />
    </g>
    <defs>
      <clipPath id="clip0_1265_2418">
        <rect width="16" height="16" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>,
  'BackBox'
);

export default BackBoxIcon;
